/**
 * @generated SignedSource<<1928e5ab54eb8b49b559d47e27fa9181>>
 * @relayHash 76445ea1702a107ead9723b5fbe52fad
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 76445ea1702a107ead9723b5fbe52fad

import { ConcreteRequest } from 'relay-runtime';
export type WaitListNid = "C4C" | "COMMUNITY_FEED" | "EXPERT_NETWORKS" | "FINANCE_INTEGRATION" | "GROWTH_RECOMMENDATIONS" | "HOURLY_ONGOING_PROJECTS" | "INDEPENDENT_PORTFOLIOS_ALPHA" | "OTHER" | "PRO_ANALYTICS" | "RATE_CALCULATOR" | "SLACK_CLIENT_INTEGRATION" | "%future added value";
export type AdminRemoveUserFromWaitListInput = {
  userId: string;
  waitListNid: string;
};
export type WaitListMenuAdminRemoveUserFromWaitListMutation$variables = {
  input: AdminRemoveUserFromWaitListInput;
};
export type WaitListMenuAdminRemoveUserFromWaitListMutation$data = {
  readonly adminRemoveUserFromWaitList: {
    readonly adminUserSearchResult: {
      readonly id: string;
      readonly waitLists: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly nid: WaitListNid;
          };
        }>;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }> | null;
  };
};
export type WaitListMenuAdminRemoveUserFromWaitListMutation = {
  response: WaitListMenuAdminRemoveUserFromWaitListMutation$data;
  variables: WaitListMenuAdminRemoveUserFromWaitListMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "AdminUserSearchResult",
  "kind": "LinkedField",
  "name": "adminUserSearchResult",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "WaitListConnection",
      "kind": "LinkedField",
      "name": "waitLists",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WaitListEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WaitList",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "nid",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WaitListMenuAdminRemoveUserFromWaitListMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminRemoveUserFromWaitListPayload",
        "kind": "LinkedField",
        "name": "adminRemoveUserFromWaitList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WaitListMenuAdminRemoveUserFromWaitListMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminRemoveUserFromWaitListPayload",
        "kind": "LinkedField",
        "name": "adminRemoveUserFromWaitList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "76445ea1702a107ead9723b5fbe52fad",
    "metadata": {},
    "name": "WaitListMenuAdminRemoveUserFromWaitListMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "eeb9fa45a3e6594050b0a5e853d3f411";

export default node;
